import {
  //cart
  ADD_OR_REMOVE,
  ADD_OR_REMOVE_FAIL,
  ADD_OR_REMOVE_SUCCESS,
  GET_USER_CART,
  GET_USER_CART_FAIL,
  GET_USER_CART_SUCCESS,

  //coupon
  COUPON_VALIDATE,
  COUPON_VALIDATE_SUCCESS,
  COUPON_VALIDATE_FAIL,

  //order
  MAKE_ORDER,
  MAKE_ORDER_SUCCESS,
  MAKE_ORDER_FAIL,
  GET_USER_ORDERS,
  GET_USER_ORDERS_SUCCESS,
  GET_USER_ORDERS_FAIL,
  GET_ORDER_DETAILS,
  GET_ORDER_DETAILS_SUCCESS,
  GET_ORDER_DETAILS_FAIL,
  RE_ORDER,
  RE_ORDER_SUCCESS,
  RE_ORDER_FAIL,
  CANCEL_ORDER,
  CANCEL_ORDER_SUCCESS,
  CANCEL_ORDER_FAIL,
  RETURN_ORDER,
  RETURN_ORDER_SUCCESS,
  RETURN_ORDER_FAIL,

  //payment
  CREATE_RAZORPAY_ORDER,
  CREATE_RAZORPAY_ORDER_SUCCESS,
  CREATE_RAZORPAY_ORDER_FAIL,
  VERIFY_RAZORPAY_ORDER,
  VERIFY_RAZORPAY_ORDER_SUCCESS,
  VERIFY_RAZORPAY_ORDER_FAIL,

  //address
  GET_USER_ADDRESS,
  GET_USER_ADDRESS_SUCCESS,
  GET_USER_ADDRESS_FAIL,
  UPDATE_USER_ADDRESS,
  UPDATE_USER_ADDRESS_SUCCESS,
  UPDATE_USER_ADDRESS_FAIL,
  DELETE_USER_ADDRESS,
  DELETE_USER_ADDRESS_SUCCESS,
  DELETE_USER_ADDRESS_FAIL,
  SET_DEFAULT_ADDRESS,
  SET_DEFAULT_ADDRESS_SUCCESS,
  SET_DEFAULT_ADDRESS_FAIL,

  //favorite
  GET_FAVORITE_ITEMS,
  GET_FAVORITE_ITEMS_SUCCESS,
  GET_FAVORITE_ITEMS_FAIL,
  ADD_OR_REMOVE_FAV,
  ADD_OR_REMOVE_FAV_SUCCESS,
  ADD_OR_REMOVE_FAV_FAIL,

  //quick purchase
  GET_QUICKLIST_ITEMS,
  GET_QUICKLIST_ITEMS_SUCCESS,
  GET_QUICKLIST_ITEMS_FAIL,

  //lealCart
  GET_LOCAL_CART,
  GET_LOCAL_CART_SUCCESS,
  GET_LOCAL_CART_FAIL,
  BULK_CART,
  BULK_CART_ADDED,
  BULK_CART_FAIL,
  UPDATE_ORDER,
  UPDATE_ORDER_SUCCESS,
  UPDATE_ORDER_FAIL,
  CLEAR_ORDER_STATE,
  CREATE_EARNING_FROM_ORDER_SUCCESS,
  CREATE_EARNING_FROM_ORDER_FAIL,
  GET_OPEN_PAYMENT_DETAILS_ORDER,
  GET_OPEN_PAYMENT_DETAILS_ORDER_SUCCESS,
  GET_OPEN_PAYMENT_DETAILS_ORDER_FAIL,
  CLEAR_ERROR,
  CLEAR_SERVER_CART,
  CREATE_PHONEPE_ORDER,
  VERIFY_PHONEPE_ORDER,
  CREATE_PHONEPE_ORDER_SUCCESS,
  CREATE_PHONEPE_ORDER_FAIL,
  VERIFY_PHONEPE_ORDER_SUCCESS,
  VERIFY_PHONEPE_ORDER_FAIL,

  //phone pay
} from "./actionTypes"

const INIT_STATE = {
  //cart
  userCart: [],
  localCart: [],
  cartItems: [],
  error: {},
  loading: false,
  addOrRemoveLoad: false,
  cartAdded: "",
  bulkLoad: false,

  //coupon
  coupon: {},
  couponLoad: false,

  //order
  allOrder: [],
  order: {},
  orderLoad: false,
  verifiedOrder: {},

  //payment
  paymentInfo: {},
  paymentVerifyInfo: {},
  paymentLoad: false,

  //address
  userAddress: {},
  addressLoad: false,

  //favorite
  favorites: {},
  favoritesLoad: false,

  //quick purchase
  quickPurchase: {},
  quickPurchaseLoad: false,

  //open payment
  openPaymentInfo: {},
  openPaymentLoad: false,

  //phone pay payment
  phonePayPaymentInfo: {},
  phonePayPaymentVerifyInfo: {},
  phonePayPaymentLoad: false,
}

const Cart = (state = INIT_STATE, action) => {
  switch (action.type) {
    //cart
    case BULK_CART:
      return {
        ...state,
        bulkLoad: true,
      }
    case GET_USER_CART:
      return {
        ...state,
        loading: true,
      }
    case GET_USER_CART_SUCCESS:
      return {
        ...state,
        userCart: action.payload,
        cartItems: action.payload?.cartItems,
        loading: false,
      }
    case GET_USER_CART_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case BULK_CART_ADDED:
      return {
        ...state,
        userCart: action.payload,
        cartItems: action.payload?.cartItems,
        localCart: [],
        bulkLoad: setTimeout(() => false, 2000),
      }
    case BULK_CART_FAIL:
      return {
        ...state,
        error: action.payload,
        bulkLoad: false,
      }

    case GET_LOCAL_CART:
      return {
        ...state,
        loading: true,
      }
    case GET_LOCAL_CART_SUCCESS:
      return {
        ...state,
        userCart: action.payload,
        localCart: action.payload,
        loading: false,
      }
    case GET_LOCAL_CART_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case ADD_OR_REMOVE:
    case RE_ORDER:
      return {
        ...state,
        addOrRemoveLoad: true,
      }
    case ADD_OR_REMOVE_SUCCESS:
      return {
        ...state,
        userCart: action.payload,
        cartAdded: action.payload.cartItems?.filter(
          i => i.varient === action.payload.myVarientId
        ),
        cartItems: action.payload.cartItems,
        addOrRemoveLoad: false,
      }
    case ADD_OR_REMOVE_FAIL:
      return {
        ...state,
        error: action.payload,
        addOrRemoveLoad: false,
      }

    //coupon
    case COUPON_VALIDATE:
      return {
        ...state,
        couponLoad: true,
      }
    case COUPON_VALIDATE_SUCCESS:
      return {
        ...state,
        coupon: action.payload,
        couponLoad: false,
      }
    case COUPON_VALIDATE_FAIL:
      return {
        ...state,
        error: action.payload,
        couponLoad: false,
      }

    //order
    case MAKE_ORDER:
    case GET_USER_ORDERS:
    case GET_ORDER_DETAILS:
    case CANCEL_ORDER:
    case RETURN_ORDER:
    case UPDATE_ORDER:
      return {
        ...state,
        orderLoad: true,
      }
    case CLEAR_ORDER_STATE:
      return {
        ...state,
        verifiedOrder: {},
        orderLoad: false,
      }
    case MAKE_ORDER_SUCCESS:
      return {
        ...state,
        order: action.payload,
        orderLoad: false,
        verifiedOrder: action.payload,
      }
    case MAKE_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
        orderLoad: false,
      }
    case UPDATE_ORDER_SUCCESS:
      return {
        ...state,
        order: action.payload,
        orderLoad: false,
      }
    case UPDATE_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
        orderLoad: false,
      }
    case GET_USER_ORDERS_SUCCESS:
      return {
        ...state,
        allOrder: action.payload,
        orderLoad: false,
      }
    case GET_USER_ORDERS_FAIL:
      return {
        ...state,
        error: action.payload,
        orderLoad: false,
      }
    case GET_ORDER_DETAILS_SUCCESS:
      return {
        ...state,
        order: action.payload,
        orderLoad: false,
      }
    case GET_ORDER_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
        orderLoad: false,
      }
    case RE_ORDER_SUCCESS:
      return {
        ...state,
        userCart: action.payload,
        cartItems: action.payload?.cartItems,
        addOrRemoveLoad: false,
      }
    case RE_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
        addOrRemoveLoad: false,
      }
    case CANCEL_ORDER_SUCCESS:
      return {
        ...state,
        order: action.payload,
        orderLoad: false,
      }
    case CANCEL_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
        orderLoad: false,
      }
    case RETURN_ORDER_SUCCESS:
      return {
        ...state,
        order: action.payload,
        orderLoad: false,
      }
    case RETURN_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
        orderLoad: false,
      }

    //payment
    case CREATE_RAZORPAY_ORDER:
      return {
        ...state,
        paymentLoad: true,
      }
    case VERIFY_RAZORPAY_ORDER:
      return {
        ...state,
        paymentLoad: true,
        paymentVerifyInfo: action.payload,
      }

    case CREATE_RAZORPAY_ORDER_SUCCESS:
      return {
        ...state,
        paymentInfo: action.payload,
        paymentLoad: false,
      }
    case CREATE_RAZORPAY_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
        paymentLoad: false,
      }

    case VERIFY_RAZORPAY_ORDER_SUCCESS:
      return {
        ...state,
        paymentVerifyInfo: { ...state.paymentVerifyInfo, ...action.payload },
        paymentLoad: false,
      }
    case VERIFY_RAZORPAY_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
        paymentLoad: false,
      }

    //address
    case GET_USER_ADDRESS:
    case DELETE_USER_ADDRESS:
    case UPDATE_USER_ADDRESS:
    case SET_DEFAULT_ADDRESS:
      return {
        ...state,
        addressLoad: true,
      }
    case GET_USER_ADDRESS_SUCCESS:
      return {
        ...state,
        userAddress: action.payload,
        addressLoad: false,
      }
    case GET_USER_ADDRESS_FAIL:
      return {
        ...state,
        error: action.payload,
        addressLoad: false,
      }
    case UPDATE_USER_ADDRESS_SUCCESS:
      console.log("action.payload", action.payload)
      return {
        ...state,
        userAddress: action.payload,
        // allAddress: action.payload,
        addressLoad: false,
      }
    case UPDATE_USER_ADDRESS_FAIL:
      return {
        ...state,
        error: action.payload,
        addressLoad: false,
      }
    case DELETE_USER_ADDRESS_SUCCESS:
      return {
        ...state,
        userAddress: action.payload,
        addressLoad: false,
      }
    case DELETE_USER_ADDRESS_FAIL:
      return {
        ...state,
        error: action.payload,
        addressLoad: false,
      }
    case SET_DEFAULT_ADDRESS_SUCCESS:
      return {
        ...state,
        userAddress: action.payload,
        addressLoad: false,
      }
    case SET_DEFAULT_ADDRESS_FAIL:
      return {
        ...state,
        error: action.payload,
        addressLoad: false,
      }

    //favourite

    case GET_FAVORITE_ITEMS:
    case ADD_OR_REMOVE_FAV:
      return {
        ...state,
        favoritesLoad: true,
      }
    case GET_FAVORITE_ITEMS_SUCCESS:
      return {
        ...state,
        favorites: action.payload,
        favoritesLoad: false,
      }
    case GET_FAVORITE_ITEMS_FAIL:
      return {
        ...state,
        error: action.payload,
        favoritesLoad: false,
      }
    case ADD_OR_REMOVE_FAV_SUCCESS:
      return {
        ...state,
        favoritesAdd: action.payload,
        favoritesLoad: false,
      }
    case ADD_OR_REMOVE_FAV_FAIL:
      return {
        ...state,
        error: action.payload,
        favoritesLoad: false,
      }

    //quick purchase
    case GET_QUICKLIST_ITEMS:
      return {
        ...state,
        quickPurchaseLoad: false,
      }
    case GET_QUICKLIST_ITEMS_SUCCESS:
      return {
        ...state,
        quickPurchase: action.payload,
        quickPurchaseLoad: false,
      }
    case GET_QUICKLIST_ITEMS_FAIL:
      return {
        ...state,
        error: action.payload,
        quickPurchaseLoad: false,
      }

    case CREATE_EARNING_FROM_ORDER_SUCCESS:
      return {
        ...state,
        earningsMsg: action.payload,
      }
    case CREATE_EARNING_FROM_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    //OPEN PAYMENT
    case GET_OPEN_PAYMENT_DETAILS_ORDER:
      return {
        ...state,
        openPaymentLoad: false,
      }

    case GET_OPEN_PAYMENT_DETAILS_ORDER_SUCCESS:
      return {
        ...state,
        openPaymentInfo: action.payload,
        openPaymentLoad: false,
      }
    case GET_OPEN_PAYMENT_DETAILS_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
        openPaymentLoad: false,
      }
    case CLEAR_ERROR:
      return {
        ...state,
        error: {},
      }
    case CLEAR_SERVER_CART:
      return {
        ...INIT_STATE,
      }

    //phone pay payment
    case CREATE_PHONEPE_ORDER:
      return {
        ...state,
        phonePayPaymentLoad: true,
      }

    case CREATE_PHONEPE_ORDER_SUCCESS:
      return {
        ...state,
        phonePayPaymentInfo: action.payload,
        phonePayPaymentLoad: false,
      }

    case CREATE_PHONEPE_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
        phonePayPaymentLoad: false,
      }

    case VERIFY_PHONEPE_ORDER:
      return {
        ...state,
        phonePayPaymentLoad: true,
        phonePayPaymentVerifyInfo: action.payload,
      }

    case VERIFY_PHONEPE_ORDER_SUCCESS:
      return {
        ...state,
        phonePayPaymentVerifyInfo: {
          ...state.phonePayPaymentInfo,
          ...action.payload,
        },
        phonePayPaymentLoad: false,
      }

    case VERIFY_PHONEPE_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
        phonePayPaymentLoad: false,
      }

    default:
      return state
  }
}

export default Cart
